import {Component, Injector} from "@angular/core";
import {provideSearchModel} from "@fedeltapointofsale/data-client";
import {
    AbstractSingleSelectEditControlComponent
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-single-select-edit-control.component";
import {EntitlementSearchModel} from "../entitlement-search.model";
import {EntitlementSearchPageComponent} from "../entitlement-search-page/entitlement-search-page.component";
import {EntitlementEditPageComponent} from "../entitlement-edit-page/entitlement-edit-page.component";
import {
    registerSelectEditControl
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-select-edit-control.component";

@Component({
    selector: "wbo-entitlement-single-select-edit-control",
    templateUrl: "../../../framework/entity/edit/edit-controls/select-edit-controls/single-select-edit-control.component.html",
    providers: [
        registerSelectEditControl(EntitlementSingleSelectEditControlComponent),
        provideSearchModel(EntitlementSearchModel)
    ]
})
export class EntitlementSingleSelectEditControlComponent extends AbstractSingleSelectEditControlComponent<EntitlementSearchModel> {
    constructor(model: EntitlementSearchModel, injector: Injector) {
        super(model, injector, "id", "summary");
        this.extendedSearchComponent = EntitlementSearchPageComponent;
        this.extendedEditComponent = EntitlementEditPageComponent;
    }
}
